module.exports = "/packs/images/products/blush-gold-device-staged-tablet-d789fc33b9813f1079e5c448850a5be6.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/images/products/blush-gold-device-staged-tablet.jpg
// module id = 1800
// module chunks = 0